// Shared toolbar used by both the master Jobs page and the per-project Jobs
// tab. Page-specific buttons (New Job, Export to Excel, etc.) go through the
// `children` slot rendered after the divider on the right.

export const jobsBulkBtn =
  "px-3 py-1.5 text-sm font-medium rounded-md border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 hover:border-gray-400 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-white disabled:hover:border-gray-300 transition-colors";

export const jobsBulkBtnDestructive =
  "px-3 py-1.5 text-sm font-medium rounded-md border border-gray-300 bg-white text-red-700 hover:bg-red-50 hover:border-red-300 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-white disabled:hover:border-gray-300 transition-colors";

const JobsActionsBar = ({ selectedCount, onAction, children }) => {
  const disabled = selectedCount === 0;

  return (
    <div className="flex gap-2 items-center text-sm">
      <button
        className={jobsBulkBtn}
        onClick={() => onAction("offer")}
        disabled={disabled}
        title="Offer selected jobs to vendor"
      >
        Offer
      </button>
      <button
        className={jobsBulkBtn}
        onClick={() => onAction("start")}
        disabled={disabled}
        title="Start selected jobs (vendor must have accepted)"
      >
        Start
      </button>
      <button
        className={jobsBulkBtn}
        onClick={() => onAction("accept")}
        disabled={disabled}
        title="Mark selected jobs as accepted by vendor"
      >
        Accept
      </button>
      <button
        className={jobsBulkBtn}
        onClick={() => onAction("draft")}
        disabled={disabled}
        title="Move selected jobs to draft"
      >
        Draft
      </button>
      <button
        className={jobsBulkBtnDestructive}
        onClick={() => onAction("cancel")}
        disabled={disabled}
        title="Cancel selected jobs"
      >
        Cancel
      </button>
      <button
        className={jobsBulkBtnDestructive}
        onClick={() => onAction("delete")}
        disabled={disabled}
        title="Delete selected jobs permanently"
      >
        Delete
      </button>

      {children && (
        <>
          <div className="mx-1 h-6 w-px bg-gray-300" />
          {children}
        </>
      )}
    </div>
  );
};

export default JobsActionsBar;
